import config from '../../../config';
import { showErrorMsg, showPermanentErrorMsg } from '../ErrorMsg';

export const duplicateProject = ({ id }) =>
  $.post(`${config.pbxApi}/project/duplicate`, {
    uuid: id
}).fail((resp) => {
  const { errors = '' } = resp.responseJSON;
  showErrorMsg(errors);
});

export const duplicateTaopixProject = ({ id, t, supportEmail }) => 
  $.post(`${config.api}/taopix/project/duplicate`, {
    taopix_project_id: id
}).fail(() => {
  showPermanentErrorMsg(t("account.reoreder_taopix_fail", `Error: There was an error in processing this order. Please contact customer support via Web Chat for faster response, or  alternatively, you can contact us via email (<a href='mailto:${supportEmail}'>${supportEmail}</a>) with the order ID`, {"supportEmail": supportEmail}));
});

export const reorderProject = (projectId) => {
  return $.post(`${config.localeApi}/cart/reorder_pbx`, {
    project_id: projectId
  }).fail((resp) => {
    const { errors = '' } = resp.responseJSON;
    showErrorMsg(errors);
  });
}

export const checkProjectInOrderItem = (uuid) => {
  return $.get(`${config.pbxApi}/project/${uuid}/checkProjectInOrderItem`).fail((resp) => {
    const { errors = '' } = resp.responseJSON;
    showErrorMsg(errors);
  });
}


// WEBPACK FOOTER //
// ./src/Common/Providers/ProjectApi.js